const teams = [
    {
        "id": 1,
        "name": "Inter",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/110.png"
    },
    {
        "id": 2,
        "name": "AC Milan",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/103.png"
    },
    {
        "id": 3,
        "name": "Juventus",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/111.png"
    },
    {
        "id": 4,
        "name": "Napoli",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/114.png"
    },
    {
        "id": 5,
        "name": "AS Roma",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/104.png"
    },
    {
        "id": 6,
        "name": "Lazio",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/112.png"
    },
    {
        "id": 7,
        "name": "Atalanta",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/105.png"
    },
    {
        "id": 8,
        "name": "Fiorentina",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/109.png"
    },
    {
        "id": 9,
        "name": "Bologna",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/107.png"
    },
    {
        "id": 10,
        "name": "Torino",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/239.png"
    },
    {
        "id": 11,
        "name": "Sassuolo",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/3997.png"
    },
    {
        "id": 12,
        "name": "Genoa",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/3263.png"
    },
    {
        "id": 13,
        "name": "Lecce",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/113.png"
    },
    {
        "id": 14,
        "name": "Cagliari",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/2925.png"
    },
    {
        "id": 15,
        "name": "Udinese",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/118.png"
    },
    {
        "id": 16,
        "name": "Como",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/2572.png"
    },
    {
        "id": 17,
        "name": "Parma",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/115.png"
    },
    {
        "id": 18,
        "name": "Cremonese",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/4050.png"
    },
    {
        "id": 19,
        "name": "Pisa",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/3956.png"
    },
    {
        "id": 20,
        "name": "Verona",
        "logo": "https://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/119.png"
    }
]

export default teams;